<template>
  <div class="w-full h-full">
    <div v-if="type === 'header'">
      <SkeletonHeader></SkeletonHeader>
    </div>
    <div v-if="type === 'block'" class="skeleton-wrapper">
      <SkeletonBlock></SkeletonBlock>
    </div>
  </div>
</template>

<script>
import SkeletonBlock from "./SkeletonBlock.vue";
import SkeletonHeader from "./SkeletonHeader.vue";

export default {
  name: "SkeletonIndex",
  props: {
    type: { type: String, default: "header" },
  },
  components: {
    SkeletonHeader,
    SkeletonBlock,
  },
};
</script>

<style lang="scss" scoped>
.skeleton-wrapper {
  @apply w-full h-screen;

  //height: calc(100vh - 100px);
}
</style>
